import { render } from "./MainFooter.vue?vue&type=template&id=9ad7489a&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=9ad7489a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad7489a"]])

export default __exports__